import  mediaService  from '@jobseeker/common-core/services/media.service';
import userService from '@jobseeker/common-core/services/user.service';
import {enqueueSnackbar} from 'notistack';
import type {Dispatch} from 'react';
import type {AnyAction} from 'redux';

const uploadResume = async (
  formData: FormData,
  dispatch: Dispatch<AnyAction>,
  showSnackbar = true
) => {
  const resumeInfo = await mediaService.uploadFile(formData);
  if (resumeInfo?.url) {
    if (showSnackbar) {
      enqueueSnackbar('Your resume has been uploaded successfully!', {
        variant: 'success',
      });
    }
    dispatch({
      type: 'User/set_user_resume_updated',
      payload: true,
    });
    return resumeInfo;
  } else {
    throw resumeInfo['error'];
  }
};

const updateResumeTimeStamp = async (isUpdate?: boolean) => {
  await userService.updateResumeStamp(isUpdate);
  return true;
};

export {uploadResume, updateResumeTimeStamp};
